import { defineStore } from 'pinia'

// light | dark | system. index.html applies the stored choice before first
// paint; this keeps it in step afterwards.
export const useTheme = defineStore('theme', {
  state: () => {
    let mode = 'system'
    try { mode = localStorage.getItem('theme') || 'system' } catch (e) { /* storage blocked */ }
    return { mode }
  },
  getters: {
    isDark: (s) => s.mode === 'dark' || (s.mode === 'system' && matchMedia('(prefers-color-scheme: dark)').matches),
  },
  actions: {
    set(mode) {
      this.mode = mode
      try { mode === 'system' ? localStorage.removeItem('theme') : localStorage.setItem('theme', mode) } catch (e) { /* storage blocked */ }
      this.apply()
    },
    toggle() {
      this.set(this.isDark ? 'light' : 'dark')
    },
    apply() {
      document.documentElement.classList.toggle('dark', this.isDark)
    },
    watchSystem() {
      matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => { if (this.mode === 'system') this.apply() })
    },
  },
})
